import { type UserList, createUserList } from 'models';
import { useInfiniteQuery } from 'query';
import { getUsers } from '../services';
import { useGetUsersParameters } from './hooks';
import { getUsersInfiniteQueryKey } from './keys';

type P = {
  excludeCommunityId?: string;
  excludeProgramId?: string;
  pageSize: number;
  search?: string;
};

export const useUsersInfiniteQuery = ({ excludeCommunityId, excludeProgramId, pageSize, search }: P) => {
  const getUsersParameters = useGetUsersParameters();

  return useInfiniteQuery<UserList[], string | undefined>({
    async queryFn({ pageParam: cursor }) {
      const { data } = await getUsers({
        config: {
          params: getUsersParameters({
            filter: { excludeCommunityId, excludeProgramId, search },
            pagination: { cursor, limit: pageSize },
          }),
        },
      });

      return data.map((user) => createUserList(user));
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => (lastPage.length < pageSize ? undefined : lastPage.at(-1)?.id),
    queryKey: getUsersInfiniteQueryKey({
      filter: { excludeCommunityId, excludeProgramId, search },
      pagination: { pageSize },
    }),
  });
};
